"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateSelect = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _useOurTranslation = require("../../utils/useOurTranslation");

var _IntroText = _interopRequireDefault(require("../IntroText"));

var _pickers = require("@material-ui/pickers");

var _dateFns = _interopRequireDefault(require("@date-io/date-fns"));

var _de = _interopRequireDefault(require("date-fns/locale/de"));

var _pl = _interopRequireDefault(require("date-fns/locale/pl"));

var _functions = require("@jobmatchme/ui/es/utils/functions");

var _Optimizers = require("../../utils/Optimizers");

var _ThemeProvider = _interopRequireDefault(require("@jobmatchme/ui/es/provider/ThemeProvider"));

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _ProfileProvider = require("../../provider/ProfileProvider");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var LocalizedUtils = /*#__PURE__*/function (_DateFnsUtils) {
  (0, _inherits2.default)(LocalizedUtils, _DateFnsUtils);

  var _super = _createSuper(LocalizedUtils);

  function LocalizedUtils() {
    (0, _classCallCheck2.default)(this, LocalizedUtils);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(LocalizedUtils, [{
    key: "getDatePickerHeaderText",
    value: function getDatePickerHeaderText(date) {
      return this.format(date, 'dd MM yyyy', {
        locale: this.locale
      });
    }
  }]);
  return LocalizedUtils;
}(_dateFns.default);
/**
 * singleChoice component for whitelabel registration funnel
 * @param {*} param0
 */


var DateSelectComponent = function DateSelectComponent(_ref) {
  var config = _ref.config,
      context = _ref.context;
  var t = (0, _useOurTranslation.useComponentTranslation)(config);

  var _useContext = (0, _react.useContext)(_ProfileProvider.ProfileActionsContext),
      setValue = _useContext.setValue;

  var handleChange = function handleChange(date) {
    setValue(config.valueName, date.getTime());
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_IntroText.default, {
      headline: t(config.translations.text),
      text: config.translations.hint ? t(config.translations.hint) : ''
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _styleModule.default.box,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ThemeProvider.default, {
        variant: 'jmm',
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_pickers.MuiPickersUtilsProvider, {
          utils: LocalizedUtils,
          locale: (0, _functions.getLocale)() === 'de' ? _de.default : (0, _functions.getLocale)() === 'pl' ? _pl.default : _de.default,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_pickers.DatePicker, {
            autoOk: true,
            disablePast: true,
            disableToolbar: true,
            variant: "static",
            format: "MM/dd/yyyy",
            value: context[config.valueName].value,
            onChange: handleChange
          })
        })
      })
    })]
  });
};

var DateSelectWrapper = (0, _Optimizers.memoizeComponentByValue)(DateSelectComponent);

var DateSelect = function DateSelect(_ref2) {
  var config = _ref2.config;
  var context = (0, _react.useContext)(_ProfileProvider.ProfileContext);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(DateSelectWrapper, {
    config: config,
    context: context
  });
};

exports.DateSelect = DateSelect;